// src/routes/RecordingRRRouter.jsx
import React, { Suspense, lazy } from "react";
import { ClipLoader } from "react-spinners"; // ✨ spinner

const RecordingRespiratoryRate = lazy(() =>
  import("recordingRespiratoryRate/App")
);

export default function RecordingRRRouter(props) {
  return (
    <Suspense
      fallback={
        <div className="flex h-full w-full items-center justify-center">
          <ClipLoader size={48} />
        </div>
      }
    >
      <RecordingRespiratoryRate {...props} />
    </Suspense>
  );
}
